// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bjfp","content":"styles_content__3PKc2","row":"styles_row__Qb-yE","footer":"styles_footer__2AdFG","phraseLength":"styles_phraseLength__6Zf06"};